import {
    DIC
} from '@/const/dic'
import {
    formatterTime
} from '@/util/util'
import {baseUrl} from '@/config/env';




export const goodsQrDetailsOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: '300',
    labelWidth: '160',
    // menuType:'menu',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [
        {
            label: "二维码编号",
            prop: "number",
            search: true,
            addVisdiplay: false,
            editVisdiplay: false,
        },
        {
            label: "二维码名称",
            prop: "name",
            type: "input"
        },
        {
            label: '店铺名称',
            prop: 'shopName',
            formsolt: true
        },
        {
            label: '商品品牌',
            prop: 'brandName',
            formsolt: true
        },
        {
            label: '商品一级分类',
            prop: 'firstClassifyName',
            formsolt: true
        },
        {
            label: '商品二级分类',
            prop: 'secondClassifyName',
            formsolt: true
        }
        ,{
            label: '商品',
            prop: 'goodsName',
            formsolt: true
        },
        {
            label: "有效期",
            prop: "startDate_endDate",
            type: "datetimerange",
            valueFormat: "timestamp",
            span: 24,
            clearable: true,
            formatter: function(row, value , label, column){
                return formatterTime(row.startTime) +'至'+formatterTime(row.endTime)
            }
        },
        {
            label: "推广费",
            prop: "promotionCost",
            type: "input"
        },
        // {
        //     label: "领取人",
        //     prop: "receiver",
        //     type: "input"
        // },
        {
            label: "提交时间",
            prop: "submitTime",
            type: "datetime",
            sortable: true,
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        }
        ,
        {
            label: "状态",
            prop: "status",
            type: "input",
            solt: true,
            addVisdiplay:false
        }

    ]
};